import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";

const HeaderLogo = () => { // Renamed component
  return (
    <Link to="/" className="flex items-center gap-2">
      <img
        src="/demenshjaltar.svg"
        alt="Demenshjältar"
        className="h-8 w-8"
      />
      <div className="flex flex-col">
        <span className="text-xl font-bold text-minnestig-teal font-poppins"> {/* Added font-poppins */}
          Demenshjältar
        </span>
        <span className="text-xs text-gray-500">Tillsammans i kampen mot demens</span> {/* Updated slogan */}
      </div>
    </Link>
  );
};

export default HeaderLogo; // Renamed export
